// SearchContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const SearchContext = createContext();

export function useSearch() {
    return useContext(SearchContext);
}

export const SearchProvider = ({ children }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    // Debouncing searchTerm dentro do contexto
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500); // Atraso de 500ms

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    return (
        <SearchContext.Provider value={{ searchTerm, setSearchTerm, debouncedSearchTerm }}>
            {children}
        </SearchContext.Provider>
    );
};
